import isSampleOrSubCollectionLocationUtil from 'utils/location/is-free-sample-or-sub-collection-location'
import isSelectSampleSelfGiftingUrlLocationUtil from 'utils/location/is-select-sample-self-gifting-url'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'
import isHomeUrlLocationUtil from 'utils/location/is-home-url'

/**
 * @param {Object} props
 * @param {boolean} props.isFullSize
 * @param {string} props.chipLabel
 * @returns {boolean}
 */
const shouldHideFullSizeChipUtil = ({
  isFullSize,
  chipLabel
}) => {
  const isValidCollection = (
    isSampleOrSubCollectionLocationUtil() ||
    isMixedCollectionUrlLocationUtil() ||
    isSelectSampleSelfGiftingUrlLocationUtil() ||
    isHomeUrlLocationUtil()
  )

  return (
    isFullSize &&
    chipLabel === 'Full size' &&
    !isValidCollection
  )
}

export default shouldHideFullSizeChipUtil
